import * as constants from './actions';

import { getInitiatedTime } from '../../utils/actionTiming';

const initialState = {};

export default function tweet(state = initialState, { type, payload }) {
    switch (type) {
        case constants.TWEET_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state)
            };
        case constants.TWEET_SUCCESS:
            return {
                ...state,
                completeTweet: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                thankYouText: payload.thankYouText,
                useLocalRepresentative: payload.useLocalRepresentative,
                localRepresentativeTweetState: payload.localRepresentativeState
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    thankYouText: payload.thankYouText,
                    thankYouTitle: payload.thankYouTitle,
                    useLocalRepresentative: payload.useLocalRepresentative,
                    localRepresentativeState: payload.localRepresentativeState,
                    id: payload.apiRequestData ? payload.apiRequestData.id : ''
                }
            };
        default:
            return state;
    }
}
